export const SET_SPONSORS = (state, data) => {
   state.sponsors = data;
}